import { get } from 'lodash';
import { searchEntities } from '../../store/selectors/search';

export const selectProperties = (state) => {
  const searchFields = [
    'name',
    'addressLine1',
    'addressLine2',
    'city',
    'province',
    'propertyManager.firstname',
    'propertyManager.lastname',
    'propertyManager.email',
  ];

  return searchEntities(state, 'properties', searchFields);
};

export const selectPropertyById = (state, id) =>
  selectProperties(state).find((p) => p.id === id);